import Config from 'config'

/**
 * @param onClick
 * @param type
 * @param marginRight
 * @param marginLeft
 * @param icon
 * @param iconComponent
 * @param text
 * @param disabled
 * @returns {JSX.Element}
 * @constructor
 */
export function ButtonMain ({
    onClick,
    type,
    marginRight = '0',
    marginLeft = '0',
    icon,
    iconComponent,
    text,
    disabled,
    width = 'auto',
    paddingVertical = '0'
  }) {
    return (
      <button
        onClick={onClick}
        type={type}
        disabled={disabled}
        className={
          `text-center block w-${width} py-${paddingVertical} mr-${marginRight} ml-${marginLeft} py-2 px-4
          text-xs font-semibold text-text-buttons-main-${Config.PLATFORM} placeholder-gray bg-bg-buttons-main-${Config.PLATFORM} rounded-lg 
          shadow-soft-white cursor-pointer transition-all duration-500 ease-in-out 
          hover:bg-buttons-main-hover-${Config.PLATFORM} hover:text-buttons-main-${Config.PLATFORM} hover:shadow-hover
          focus:outline-none hover:shadow-inner`
        }
      >
        {icon && (
          <img src={icon} alt="Icon" className={'inline | mr-2 | w-auto'} />
        )}
        {iconComponent && iconComponent}
        {text}
      </button>
    )
}
